module.exports = __webpack_public_path__ + "img/back invisible zipper length.30237f98.png";